export default ($mdThemingProvider, $provide) => {
  $mdThemingProvider.generateThemesOnDemand(true);
  $provide.value('ThemeProvider', $mdThemingProvider);
};
